// extracted by mini-css-extract-plugin
export default {"container":"trainingList_container__Gq0+5","description":"trainingList_description__By+FN"};